import { DatePicker, Form, Input } from 'antd';
import type { FormInstance } from 'antd';
import dayjs from 'dayjs';
import React, { FC } from 'react';

import { dateFormat } from '../../../common/constants';
import { checkDateIsValid } from '../../../common/helpers';
import styles from './Worksheet.module.scss';

type Props = {
  form: FormInstance;
};

const LegalFields: FC<Props> = () => {
  return (
    <div>
      <Form.Item
        className={styles['form-item']}
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="fullNameRu"
        label="Полное именование компании на русском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="shortNameRu"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Сокращенное наименование компании на русском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="fullNameEn"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Полное наименование компании на англ. языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="shortNameEn"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Сокращенное наименование компании на англ. языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="inn"
        className={styles['form-item']}
        label="ИНН (Налоговый номер юридического лица в стране регистрации)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        getValueProps={(value) => ({
          value: checkDateIsValid(value) ? dayjs(value) : null,
        })}
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="regDate"
        className={styles['form-item']}
        label="Дата регистрации юр.лица"
      >
        <DatePicker placeholder="Выберете дату" format={dateFormat} />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="registrationAuthorityRu"
        className={styles['form-item']}
        label="Наименование регистрирующего органа на русском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="registrationAuthorityEn"
        className={styles['form-item']}
        label="Наименование регистрирующего органа на английском языке	"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="regNumber"
        className={styles['form-item']}
        label="Регистрационный номер"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="addressRu"
        className={styles['form-item']}
        label="Адрес регистрации на руссом языке (юр.адрес)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        name="addressEn"
        label="Адрес регистрации на английском языке (юр.адрес)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="eMail"
        className={styles['form-item']}
        label="Адрес эл.почты организации (для договора и официальной переписки)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="phone"
        className={styles['form-item']}
        label="Контактный телефон организации (для договора и звонков)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="basisRuGC"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Основание представителя на русском языке (в Родительном падеже)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="basisEn"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="Основание представителя на английском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="signatoryRu"
        className={styles['form-item']}
        label="ФИО представителя на русском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="signatoryEn"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="ФИО представителя на английском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="signatoryPositionRu"
        className={styles['form-item']}
        label="Наименование должности представителя на русском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="signatoryPositionEn"
        className={styles['form-item']}
        label="Наименование должности представителя на английском языке"
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="signatoryRu"
        rules={[{ required: true, message: 'Обязательное поле' }]}
        className={styles['form-item']}
        label="ФИО представителя на русском языке (в родительном падеже)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="signatoryPositionRuGC"
        className={styles['form-item']}
        label="Наименование должности представителя (в родительном падеже)"
      >
        <Input />
      </Form.Item>

      <Form.Item
        rules={[{ required: true, message: 'Обязательное поле' }]}
        name="eMailOrganization"
        className={styles['form-item']}
        label="Эл. почта, которая указывается в договоре, и является почтой, с которой принимаются заявки"
      >
        <Input type="email" />
      </Form.Item>
    </div>
  );
};

export default LegalFields;
